(() => {
  const groups = [
    { key: "destinations", label: "Cruise Destinations" },
    { key: "month", label: "Month of Departure" },
    { key: "port", label: "Port of Departure" },
    { key: "ship", label: "Cruise Ship" },
    { key: "instructors", label: "Quilting Instructors" },
  ];

  function init(panel) {
    if (panel.dataset.cruiseFiltersReady) return;
    const section = panel.closest(".collection-section");
    const grid = section?.querySelector("[data-collection-products] .grid");
    if (!grid) return;
    // cc-cruise-supersedes-v1: an explicitly replaced legacy product stays in Shopify, with one public cruise card.
    const allCards = Array.from(grid.querySelectorAll(":scope > [data-cruise-card]"));
    const replaced = new Set();
    for (const card of allCards) {
      if (!card.dataset.ccCruisePage) continue;
      try {
        const paths = JSON.parse(card.dataset.ccCruiseReplaces || "[]");
        if (Array.isArray(paths)) for (const path of paths) {
          if (typeof path === "string" && /^\/products\/[a-zA-Z0-9%._~-]+$/.test(path)) replaced.add(path);
        }
      } catch { /* An invalid optional replacement list never hides a product. */ }
    }
    const cards = allCards.filter((card) => {
      const href = card.querySelector("a[href]")?.getAttribute("href");
      if (!card.dataset.ccCruisePage && replaced.has(href)) { card.hidden = true; return false; }
      return true;
    });
    if (!cards.length) return;
    panel.dataset.cruiseFiltersReady = "true";

    cards.forEach((card, index) => {
      card.dataset.cruiseOrder = String(index);
    });
    const valuesFor = (card, key) =>
      (card.dataset[`cruise${key[0].toUpperCase()}${key.slice(1)}`] || "")
        .split("|")
        .map((value) => value.trim())
        .filter(Boolean);
    const selections = new Map();
    const controls = panel.querySelector("[data-cruise-facets]");
    const count = section.querySelector("[data-products-count]");
    const empty = panel.querySelector("[data-cruise-empty]");
    const clear = panel.querySelector("[data-cruise-clear]");
    const sort = panel.querySelector("[data-cruise-sort]");
    const url = new URL(window.location.href);

    for (const group of groups) {
      const available = [...new Set(cards.flatMap((card) => valuesFor(card, group.key)))].sort((a, b) =>
        a.localeCompare(b, undefined, { numeric: true })
      );
      const selected = new Set(url.searchParams.getAll(`cruise_${group.key}`).filter((value) => available.includes(value)));
      selections.set(group.key, selected);
      const details = document.createElement("details");
      details.className = "sh-cruise-facet";
      details.open = selected.size > 0;
      const summary = document.createElement("summary");
      summary.textContent = group.label;
      summary.dataset.cruiseFacetSummary = group.key;
      details.append(summary);
      const options = document.createElement("div");
      options.className = "sh-cruise-facet__options";
      for (const value of available) {
        const label = document.createElement("label");
        label.className = "sh-cruise-facet__option";
        const checkbox = document.createElement("input");
        checkbox.type = "checkbox";
        checkbox.value = value;
        checkbox.checked = selected.has(value);
        checkbox.addEventListener("change", () => {
          if (checkbox.checked) selected.add(value);
          else selected.delete(value);
          render();
        });
        label.append(checkbox, document.createTextNode(value));
        options.append(label);
      }
      details.append(options);
      controls.append(details);
    }

    sort.value = url.searchParams.get("cruise_sort") || "soonest";
    sort.addEventListener("change", render);
    clear.addEventListener("click", () => {
      for (const selected of selections.values()) selected.clear();
      controls.querySelectorAll('input[type="checkbox"]').forEach((input) => {
        input.checked = false;
      });
      render();
    });

    function render() {
      let visible = 0;
      for (const card of cards) {
        const matches = groups.every(({ key }) => {
          const selected = selections.get(key);
          return !selected.size || valuesFor(card, key).some((value) => selected.has(value));
        });
        card.hidden = !matches;
        if (matches) visible += 1;
      }
      const ordered = [...cards];
      if (sort.value === "soonest") {
        ordered.sort((a, b) =>
          (a.dataset.cruiseSailDate || "9999").localeCompare(b.dataset.cruiseSailDate || "9999") ||
          Number(a.dataset.cruiseOrder) - Number(b.dataset.cruiseOrder)
        );
      } else if (sort.value === "title") {
        ordered.sort((a, b) => (a.dataset.cruiseTitle || "").localeCompare(b.dataset.cruiseTitle || ""));
      } else {
        ordered.sort((a, b) => Number(a.dataset.cruiseOrder) - Number(b.dataset.cruiseOrder));
      }
      ordered.forEach((card) => grid.append(card));
      grid.classList.toggle("sh-cruise-grid--single", visible === 1);
      const label = `${visible} ${visible === 1 ? "cruise" : "cruises"}`;
      if (count) {
        count.textContent = label;
        count.dataset.productsCount = label;
      }
      empty.hidden = visible !== 0;
      clear.hidden = ![...selections.values()].some((selected) => selected.size);
      for (const { key, label: groupLabel } of groups) {
        const summary = controls.querySelector(`[data-cruise-facet-summary="${key}"]`);
        const size = selections.get(key).size;
        if (summary) summary.textContent = size ? `${groupLabel} (${size})` : groupLabel;
      }
      const next = new URL(window.location.href);
      for (const { key } of groups) {
        next.searchParams.delete(`cruise_${key}`);
        for (const value of selections.get(key)) next.searchParams.append(`cruise_${key}`, value);
      }
      next.searchParams.delete("cruise_sort");
      if (sort.value !== "recommended") next.searchParams.set("cruise_sort", sort.value);
      if (next.href !== window.location.href) history.replaceState({}, "", next);
    }

    render();
  }

  const initAll = () => document.querySelectorAll("[data-cruise-filter-panel]").forEach(init);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initAll, { once: true });
  else initAll();
  document.addEventListener("shopify:section:load", initAll);
})();
